import { rem } from 'polished'
import { css } from 'styled-components'

export const CHAT_MAP_CARD_IMAGE_SIZE = 120

/** A floor, not a ceiling: a LuxPlus+ price stack under a 2-line title outgrows it, and a hard
 *  height cropped whichever lost. */
const CHAT_MAP_CARD_MIN_HEIGHT = 160

export const chatMapCardContainer = css`
  display: flex;
  flex-direction: row;
  border-radius: ${props => props.theme.borderRadius.M};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  overflow: hidden;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  transition: border-color 0.15s ease;
  min-height: ${rem(CHAT_MAP_CARD_MIN_HEIGHT)};

  &:hover {
    border-color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }

  /* Driven by the map pin, not the pointer. */
  &.highlighted {
    border-color: ${props => props.theme.palette.highlight.primary.darkForeground};
  }
`
